import AnalysisAndReporting, { useAnalysisAndReporting } from '@qualitas/reporting';

const PortfolioDetailsReporting = (props: any) => {
  	const { api, userContactId } = props;

  	const queryString = window.location.search;
	const allParams = new URLSearchParams(queryString);
	let searchParams = allParams?.get('report');

	const { ...reportingPropsPortfolioDetail } = useAnalysisAndReporting({
		api,
		hasMenu: true,
		searchParams,
		appName: 'Track Wizard',
		userContactId,
	});

	return (
		<AnalysisAndReporting
			{...reportingPropsPortfolioDetail}
			hasMenu
		/>
	);
};

export default PortfolioDetailsReporting;
